import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { Checkbox } from './checkbox/checkbox.component';
import { ErrorTagComponent } from './error-tag/error-tag.component';
import { Label } from './label/label.component';

@NgModule({
  imports: [CommonModule, AngularMaterialModule, CoreModule, ReactiveFormsModule],
  exports: [
    Label,
    Checkbox,
    ErrorTagComponent,
  ],
  declarations: [
    Label,
    Checkbox,
    ErrorTagComponent,
  ],
})
export class FormComponentsModule {}
